import { STICKER_FORMAT } from '@upstart/harmony/lib/legos/constants';
import BackendService from './BackendService';

export default class PencilService {
  static getPencilList(dealId, hash) {
    const params = {
      polling: true,
      hash,
    };
    return BackendService.get(`/pencils/${dealId}/all`, {
      params,
    });
  }

  static getPencil(pencilId) {
    return BackendService.get(`/pencils/${pencilId}`);
  }

  static getDefaultPencil(dealId, carId) {
    return BackendService.get(`/pencils/${dealId}/default/${carId}`);
  }

  static getDefaultTaxRates({
    dealId,
    isForceTaxByDealerForTaxCalculation,
    financeType,
  }) {
    const params = {
      isForceTaxByDealerForTaxCalculation,
      financeType,
    };
    return BackendService.get(`/pencils/${dealId}/defaultTaxRates`, {
      params,
    });
  }

  static createPencil(dealId, pencil) {
    return BackendService.post(`/pencils/${dealId}`, {
      body: pencil,
    });
  }

  static updatePencil(pencilId, pencil) {
    return BackendService.put(`/pencils/${pencilId}`, {
      body: pencil,
    });
  }

  static pushToCRM(dealId, pencilId) {
    return BackendService.post(`/pencils/${dealId}/${pencilId}/push`);
  }

  static getSticker(dealId, pencil, stickerFormat = STICKER_FORMAT.JPG) {
    return BackendService.post(`/pencils/${dealId}/sticker`, {
      body: pencil,
      params: { stickerFormat },
    });
  }

  static sendSticker(dealId, pencilId, sendParams, configPencilData) {
    return BackendService.post(`/pencils/${dealId}/${pencilId}/sticker/send`, {
      body: {
        ...sendParams,
        configPencilData,
      },
    });
  }
  static removeExpiredIncentives(pencilId, dealId, carId) {
    return BackendService.post(`/pencils/removeExpiredIncentives`, {
      body: {
        dealId,
        carId,
        pencilId,
      },
    });
  }
  static removeUnavailableAccessories(pencilId, dealId, carId) {
    return BackendService.post(`/pencils/removeUnavailableAccessories`, {
      body: {
        dealId,
        carId,
        pencilId,
      },
    });
  }
}
